import React, { useState, useEffect } from 'react';
import { Page, Link, Icon } from 'framework7-react';
import axios from 'axios';
import { API_BASE_URL, API_AUTH } from './../globals';
const requestImage = require('./../images/icons/request.png');
const feedbackImage = require('./../images/icons/feedback.png');
const acceptImage = require('./../images/icons/accept.png');
const deliveredImage = require('./../images/icons/delivered.png');
const cancelImage = require('./../images/icons/cancel.png');
const Notification = () => {
  const [data, setData] = useState([]);
  
  useEffect(() => {
    
    axios.get(API_BASE_URL + 'notification/id/'+localStorage.getItem('id'), {
        headers: {
          'Authorization': 'Basic ' + API_AUTH
        }
      })
      .then(response => setData(response.data))
      .catch(error => console.log(error));
  }, []);
  return (
    <Page className='bg-white'>
      {/* <Navbar title="Restaurant Information" backLink="Back" noShadow/>             */}
      <div className="container container-table">
        <div className="row vertical-center-row col col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon></Link>
                <h2>Notifications</h2>
              </div>
            </div>
          </header>
          <section className="section-t-space profile-form mt-3">
            <div className="custom-container p-0">
              <div className="row gy-3">
                {data.map(item => (
                  <div className="bid-web-view-div">
                    <ul class="notifications-div">
                    {item.data !== item.date ?'' :item.date} 
                  {/* <div className={`vertical-product-box order-box ${item.noti_type === 1 ? 'bid-request-clr' : item.noti_type === 2 ? 'bid-review-clr' : item.noti_type === 3 ? 'bid-confirm-clr' :item.noti_type === 4 ? 'bid-delivery-clr':item.noti_type === 5 ? 'bid-canceled-clr':" "}`}> */}
                    <li class="notification-box unread">
                      {/* <div class="notification-icon">
                        <span>
                          <img class="notification-img img1" src="assets/images/svg/close.svg" alt="close"/>
                        </span>
                      </div> */}
                      <div class="notification-content">
                        <div className='notification-head'>
                            <div> <h5>{item.notification}</h5></div> 
                            <div><h6 >{item.date_time}</h6></div>   
                        </div>
                        <h6>{item.cust_name}</h6>
                        <p>{                        
                          item.message.replace('[cust_name]', item.cust_name).replace('[event_name]', item.event_name)                        
                        }</p>
                        {/* <p>i hope you understand this and thank you in advance for support us.</p> */}
                      </div>
                    </li>
                    
                    {/* <div className="logo-notification">
                      <img className="img-fluid img" src={item.noti_type === 1 ? requestImage : item.noti_type === 2 ? feedbackImage : item.noti_type === 3 ? acceptImage :item.noti_type === 4 ? deliveredImage:item.noti_type === 5 ? cancelImage:" "} alt="vp1" />
                      </div>
                      <div className="vertical-box-details">
                      <div className="vertical-box-head">
                      <div className="restaurant d-flex justify-content-between col">
                      <h5 className="dark-text col-6">
                      {item.noti_type === 1 ? 'Bid Requested' : item.noti_type === 2 ? 'bid Reviewed' : item.noti_type === 3 ? 'bid Accepted' :item.noti_type === 4 ? 'bid Delivered':item.noti_type === 5 ? 'bid Delivered':" "}
                      </h5>
                      <h6 className="food-items text-black mb-2">{item.date_time}</h6>
                      </div>
                      <h6 className="food-items mb-2">{item.cust_name}
                      </h6>
                      </div>
                    </div> */}
                    {/* </div> */}
                    </ul>
                </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </div>

    </Page>
  );
}

export default Notification;